module.exports = __webpack_public_path__ + "img/pre_eg_2.42889733.png";